// extracted by mini-css-extract-plugin
export default {"card":"MyTeam_card__y3MmT","pfp":"MyTeam_pfp__BOlKP","teamMemberPhoto":"MyTeam_teamMemberPhoto__6H-Pr"};